@let userRole = (user$ | async)?.role ?? '';
<div class="sub-container">
  <div class="d-flex">
    <app-table-search (filterChanged)="onFilterChanged($event)"></app-table-search>
  </div>
  <app-buttons
    [isDisabled]="false"
    [name]="btnName"
    [buttonType]="btnMatStroked"
    [buttonStyle]="btnStyleStroked"
    (buttonClickEvent)="openFileUploadModal()"
  ></app-buttons>
</div>
<app-table
  [displayedColumnLabels]="displayedColumnLabels"
  [displayedColumns]="displayedColumns"
  [showActionButtonsInPagination]="false"
  [dataSource]="dataSource"
  [showActionColumn]="['SuperAdmin', 'Admin', 'Manager'].includes(userRole)"
  [showDeleteButton]="showDeleteButton"
  (deleteClicked)="openDeletePopup($event)"
  [showCheckbox]="showCheckboxInTable"
>
</app-table>
